import { FC, PropsWithChildren } from 'react';

interface DrawerHeaderProps {
  className?: string;
}

export const DrawerHeader: FC<PropsWithChildren<DrawerHeaderProps>> = ({
  children,
  className,
}) => {
  return (
    <div className={className} slot="header">
      {children}
    </div>
  );
};
